"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var theme_1 = require("../theme"); // tslint:disable-line
var Tag_1 = tslib_1.__importDefault(require("../Tag")); // tslint:disable-line
exports.Text = function (_a) {
    var ariaLabel = _a.ariaLabel, _b = _a.as, as = _b === void 0 ? 'span' : _b, children = _a.children, color = _a.color, fontFamily = _a.fontFamily, fontSize = _a.fontSize, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, textAlign = _a.textAlign, textTransform = _a.textTransform, wordBreak = _a.wordBreak, props = tslib_1.__rest(_a, ["ariaLabel", "as", "children", "color", "fontFamily", "fontSize", "fontWeight", "lineHeight", "textAlign", "textTransform", "wordBreak"]);
    var Tag = Tag_1.default(as);
    return (react_1.default.createElement(Tag, tslib_1.__assign({ "aria-label": ariaLabel }, props), children));
};
var TextStyled = theme_1.styled(exports.Text)(function (_a) {
    var color = _a.color, fontFamily = _a.fontFamily, fontSize = _a.fontSize, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, textAlign = _a.textAlign, textTransform = _a.textTransform, theme = _a.theme, wordBreak = _a.wordBreak;
    return ({
        color: (color) ? theme.palette[color] : null,
        fontFamily: (fontFamily) ? theme.font[fontFamily] : 'inherit',
        fontSize: (fontSize) ? (theme.typography[fontSize] || theme.fontSizes[fontSize]) : null,
        fontWeight: (fontWeight) ? theme.weights[fontWeight] : null,
        lineHeight: (lineHeight) ? theme.lineHeights[lineHeight] || lineHeight : 'inherit',
        textAlign: textAlign,
        textTransform: textTransform,
        wordBreak: wordBreak
    });
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign ? ({ display: 'grid' }) : null;
});
exports.default = TextStyled;
